import React from 'react';
import { connect } from 'react-redux';
import CardCompte from './CardCompte';
import CardCoordonnees from './CardCoordonnees';
import CardEcourrier from './CardEcourrier';
import CardGestionnaire from './CardGestionnaire';
import CardLots from './CardLots';
import CardPrelevement from './Prelevement/CardPrelevement';
import CardAvance from './CardAvance';
import CardAG from '../Accueil/CardAG';
import CardFacturationElectronique from './CardFacturationElectronique';

const MesInfos = ({ paramFE }) => {
    // Index 0: Infos (SIREN/SIRET), Index 1: Adresses (Tableau)
    const droitInfo = (paramFE && paramFE.length > 0) ? paramFE[0] : 0;
    const droitAdresse = (paramFE && paramFE.length > 1) ? paramFE[1] : 0;

    // On n'affiche le bloc principal que si au moins l'un des deux droits est > 0
    const estVisibleFE = (droitInfo > 0 || droitAdresse > 0);

    return (
        <div className="MesInfos">
            <div className="row">
                <div className="col-lg-6 col-xl-4">
                    <CardCompte />
                    <CardCoordonnees />
                    <CardGestionnaire />
                </div>
                <div className="col-lg-6 col-xl-8">
                    <div className="row">
                        <div className="col-xl-12"><CardLots /></div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6">
                            <CardEcourrier />
                            {estVisibleFE && <CardFacturationElectronique />}
                            <CardAvance />
                        </div>
                        <div className="col-xl-6">
                            <CardPrelevement />
                            <CardAG />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    paramFE: (state.ProStore && state.ProStore.Pro) ? state.ProStore.Pro.ParamAGVisibleFE || [] : []
});

export default connect(mapStateToProps)(MesInfos);


// WEBPACK FOOTER //
// ./src/components/MesInfos/index.js